import { UseFormSetValue } from "react-hook-form";

import { IDemandeInscriptionData } from "../../../../models/interfaces/IDemandeInscription";
import { parseISBN, convertFichiersToFiles } from "./fileHelpers";
import { IFormInscription } from "../types";

/**
 * Pré-remplit le formulaire avec les données d'une demande existante
 */
export const prefillFormFromDemande = (
  demande: IDemandeInscriptionData,
  setValue: UseFormSetValue<IFormInscription>
): void => {
  // Informations société
  if (demande.IdPays) {
    setValue("IdPays", demande.IdPays);
  }
  if (demande.Siren) {
    setValue("Siren", demande.Siren);
  }
  if (demande.RaisonSocialeSiren) {
    setValue("RaisonSocialeSiren", demande.RaisonSocialeSiren);
  }
  if (demande.RaisonSociale) {
    setValue("RaisonSociale", demande.RaisonSociale);
  }
  if (demande.Adresse) {
    setValue("Adresse", demande.Adresse);
  }
  if (demande.CodePostal) {
    setValue("CodePostal", demande.CodePostal);
  }
  if (demande.Ville) {
    setValue("Ville", demande.Ville);
  }
  if (demande.SiteInternet) {
    setValue("SiteInternet", demande.SiteInternet);
  }

  // Informations demandeur
  if (demande.IdCivilite) {
    setValue("IdCivilite", demande.IdCivilite);
  }
  if (demande.Nom) {
    setValue("Nom", demande.Nom);
  }
  if (demande.Prenom) {
    setValue("Prenom", demande.Prenom);
  }
  if (demande.Telephone) {
    setValue("Telephone", demande.Telephone);
  }
  if (demande.IdFonction) {
    setValue("Fonction", demande.IdFonction.toString());
  }

  // Informations complémentaires
  if (demande.GLNEditeur) {
    setValue("GLNEditeur", demande.GLNEditeur.toString());
  }
  if (demande.Marque) {
    setValue("MarquePrincipale", demande.Marque);
  }
  if (demande.IdSecteurActivite) {
    setValue("IdSecteurActivite", demande.IdSecteurActivite);
  }
  if (demande.GLNDiffuseur) {
    setValue("GLNDiffuseur", demande.GLNDiffuseur.toString());
  }
  if (demande.Commentaires) {
    setValue("Message", demande.Commentaires);
  }

  // ISBN
  if (demande.ISBN) {
    const isbnParts = parseISBN(demande.ISBN);
    if (isbnParts) {
      setValue("IndicatifISBN", isbnParts.indicatif);
      setValue("ISBN1", isbnParts.isbn1);
      setValue("ISBN2", isbnParts.isbn2);
    }
  }
  
  // ISBN13/EAN Complet
  if (demande.ISBN13EANComplet) {
    setValue("ISBN13EANComplet", demande.ISBN13EANComplet);
  }

  // Checkboxes
  setValue("AcceptationCGU", demande.AcceptationCGU ?? false);

  // Pièces justificatives
  const files = convertFichiersToFiles(demande.Fichiers);
  if (files.length > 0) {
    setValue("PiecesJustificatives", files);
    console.log("Pièces justificatives chargées:", files.length);
  }
};
